<mat-toolbar class="mat-elevation-z4">
  <span fxFlex> Justificar Avisos </span>
</mat-toolbar>

<div style="padding: 8px 16px; display: flex; align-items: center; gap: 8px;">
  <button
    mat-stroked-button
    [color]="filterNoShift ? 'primary' : ''"
    (click)="toggleNoShiftFilter()"
    style="border-radius: 16px; font-size: 0.85em;">
    <mat-icon style="font-size: 18px; height: 18px; width: 18px; vertical-align: middle;">
      {{ filterNoShift ? 'check' : 'filter_list' }}
    </mat-icon>
    Sin guardia asignada
  </button>
</div>

<p-table
  #table
  responsiveLayout="scroll"
  lazy="true"
  [rows]="20"
  (onLazyLoad)="onLazyLoad($event)"
  [paginator]="true"
  [totalRecords]="totalElements"
  [value]="rows"
  dataKey="callId"
  sortField="date"
  [sortOrder]="-1"
  tableStyleClass="mat-elevation-z4 size-s">
  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="id" style="width: 80px">
        <p-sortIcon field="id"></p-sortIcon>
        N° Aviso
        <p-columnFilter
          type="numeric"
          display="menu"
          field="id">
        </p-columnFilter>
      </th>

      <th pSortableColumn="lawyerName">
        <p-sortIcon field="lawyerName"></p-sortIcon>
        Abogado
        <p-columnFilter
          type="text"
          display="menu"
          field="lawyerName">
        </p-columnFilter>
      </th>

      <th pSortableColumn="date">
        <p-sortIcon field="date"></p-sortIcon>
        Fecha
        <p-columnFilter
          type="date"
          display="menu"
          field="date">
        </p-columnFilter>
      </th>

      <th pSortableColumn="judicialDistrict.name">
        <p-sortIcon field="judicialDistrict.name"></p-sortIcon>
        Partido Judicial
        <p-columnFilter
          field="judicialDistrict.id"
          matchMode="contains"
          display="menu"
          [showMatchModes]="false"
          [showOperator]="false"
          [showAddButton]="false">
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <p-multiSelect
              [ngModel]="value"
              [options]="filters?.judicialDistricts"
              (onChange)="filter($event.value)"
              optionValue="id"
              optionLabel="name">
            </p-multiSelect>
          </ng-template>
        </p-columnFilter>
      </th>

      <th pSortableColumn="alertType.name">
        <p-sortIcon field="alertType.name"></p-sortIcon>
        Materia
        <p-columnFilter
          field="alertType.id"
          matchMode="contains"
          display="menu"
          [showMatchModes]="false"
          [showOperator]="false"
          [showAddButton]="false">
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <p-multiSelect
              [ngModel]="value"
              [options]="filters?.alertsType"
              (onChange)="filter($event.value)"
              optionValue="id"
              optionLabel="name">
            </p-multiSelect>
          </ng-template>
        </p-columnFilter>
      </th>

      <th pSortableColumn="justificationStatus" style="width: 60px">
        <p-sortIcon field="justificationStatus"></p-sortIcon>
        Estado

        <p-columnFilter
          field="justificationStatus"
          matchMode="contains"
          display="menu"
          [showMatchModes]="false"
          [showOperator]="false"
          [showAddButton]="false">
          <ng-template pTemplate="filter" let-value let-filter="filterCallback">
            <p-multiSelect
              [ngModel]="value"
              [options]="justificationStatusOptions"
              (onChange)="onJustificationStatusFilter($event.value); filter($event.value)"
              optionValue="value"
              optionLabel="label"
              [filter]="false">
            </p-multiSelect>
          </ng-template>
        </p-columnFilter>
      </th>

      <th style="width: 48px"></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row>
    <tr>
      <td class="sort-padding">
        {{ row.alertId }}
      </td>

      <td class="sort-padding">
        {{ row.lawyerName }}
      </td>

      <td class="sort-padding">
        {{ row.date | date: 'dd/MM/yy HH:mm' }}
      </td>

      <td class="sort-padding">
        {{ row.judicialDistrict }}
      </td>

      <td class="sort-padding">
        {{ row.alertType }}
      </td>

      <td>
        <mat-icon
          [svgIcon]="justificationStatusIcon(row.justificationStatus)"
          [ngClass]="justificationStatusColor(row.justificationStatus)"
          [matTooltip]="getJustificationTooltip(row.justificationStatus, row.rejectionReason)">
        </mat-icon>
      </td>

      <td>
        <button mat-icon-button [matMenuTriggerFor]="callMenu">
          <mat-icon svgIcon="dots-vertical"></mat-icon>
        </button>
        <mat-menu #callMenu="matMenu">
          <button
            mat-menu-item
            *ngIf="row.justificationStatus !== 'ACCEPTED'"
            (click)="approve(row)">
            <mat-icon svgIcon="check-circle-outline"></mat-icon>
            <span>Aceptar</span>
          </button>

          <button
            mat-menu-item
            *ngIf="row.justificationStatus !== 'REJECTED'"
            (click)="reject(row)">
            <mat-icon svgIcon="close-circle-outline"></mat-icon>
            <span>Rechazar</span>
          </button>
        </mat-menu>
      </td>
    </tr>
  </ng-template>
</p-table>
